export const cookieService = {
  getCookie: (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';').map(keyValue => keyValue.trim());
    const value = ca.find(keyValue => new RegExp(name, 'i').test(keyValue));
    return value && value.substring(name.length) || '';
  }
};
